export const pageIds = {
  CUSTOM_WIZARD: 'CUSTOM_WIZARD',
  PERSONA_WIZARD: 'PERSONA_WIZARD',
  PERSONA_WIZARD_INTRO: 'PERSONA_WIZARD_INTRO',
}
